module.exports = __webpack_public_path__ + "img/barrage_prize_04.7d2b2b64.png";